<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
    scrollable
  >
    <v-card class="pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
          <p class="text-body-2 greytext--text mb-2 ml-5">
            {{ $t("labelTitle") }}
          </p>
          <v-text-field
            v-model="title"
            data-testid="dialog-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2"
            :rules="titleRules"
            clearable
            :placeholder="$t('confirmationDialogInputPlaceholderHubCategory')"
          />
          <p class="text-body-2 greytext--text mb-2 ml-5">
            {{ $t("labelDescription") }}
          </p>
          <v-textarea
            v-model="description"
            data-testid="dialog-textarea"
            solo
            class="rounded-xxl text-body-2"
            :placeholder="$t('confirmationDialogInputTextAreaPlaceholderHubCategory')"
            :rules="descriptionRules"
          />
          <p class="text-body-2 greytext--text mb-2 ml-5">
            {{ $t("labelBackgroundColor") }}
          </p>
          <div class="my-5" data-testid="color-buttons">
              <v-btn
                v-for="(color, index) in colorPalleteRow1"
                :key="'row1'+index"
                class="ma-1 pa-0"
                height="32"
                width="32"
                min-width="32"
                :color="color"
                @click="setColor(color)"
              >
                <v-icon
                  v-if="selectedColor == color"
                  color="greytext"
                >
                  mdi-check
                </v-icon>
              </v-btn>
              <br/>
              <v-btn
                v-for="(color, index) in colorPalleteRow2"
                :key="'row2'+index"
                class="ma-1 pa-0"
                height="32"
                width="32"
                min-width="32"
                :color="color"
                @click="setColor(color)"
              >
                <v-icon
                  v-if="selectedColor == color"
                  color="greytext"
                >
                  mdi-check
                </v-icon>
              </v-btn>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show=false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="submitDialogBtn()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters, ruleValidMin2Characters } from '../rules/formRules.js';
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    loading: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data(){
      return{
        valid: true,
        titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
        title: '',
        description: '',
        color: '',
        colorPalleteRow1:["#FFFFFF", "#BBDEFB", "#C8E6C9", "#FFF9C4", "#FFE0B2", "#FFCDD2"],
        colorPalleteRow2:["#E0E0E0", "#64B5F6", "#81C784", "#FFF176", "#FFB74D", "#E57373"],
        showAdvancedColors: false,
        showAdvancedColorsButton: false ,
        selectedColor: '#FFFFFF',
        descriptionRules: ruleValidMin2Characters('labelDescription'),
      }
    },    
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                    this.$refs.form.reset()
                }
            }
        }
    },
    created() {
      if(Object.keys(this.item).length > 0){
        this.title = this.item.attributes.title
        this.description = this.item.attributes.description
        this.selectedColor = this.item.attributes.bg_color
      }
    },
    methods: {
      submitDialogBtn() {
        this.valid = this.$refs.form.validate()
        if(this.valid){
          this.$emit('proceedSubmit',this.title, this.description, this.selectedColor, this.item)
        }
      },
      setColor(val){
        this.selectedColor = val
      },
      rgb2hex(orig) {
            if(orig != undefined){
                var a, isPercent,
                rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
                alpha = (rgb && rgb[4] || "").trim(),
                hex = rgb ? "#" +
                (rgb[1] | 1 << 8).toString(16).slice(1) +
                (rgb[2] | 1 << 8).toString(16).slice(1) +
                (rgb[3] | 1 << 8).toString(16).slice(1) : orig;
            if (alpha !== "") {
                isPercent = alpha.indexOf("%") > -1;
                a = parseFloat(alpha);
                if (!isPercent && a >= 0 && a <= 1) {
                a = Math.round(255 * a);
                } else if (isPercent && a >= 0 && a <= 100) {
                a = Math.round(255 * a / 100)
                } else {
                a = "";
                }
            }
            if (a) {
                hex += (a | 1 << 8).toString(16).slice(1);
            }
            return hex;
            }
        },
  },
}
</script>